const alphaCharacters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";

/**
 * @param {Array} list of objects
 * @returns {Array} list of objects with new property alphaID
 */
const AssignAlphaID = list => {
  return list.map((item, index) => {
    let alphaID;
    if (index >= alphaCharacters.length) {
      alphaID = alphaCharacters[index % alphaCharacters.length].repeat(
        Math.trunc(index / alphaCharacters.length) + 1
      );
    } else {
      alphaID = alphaCharacters[index];
    }

    return {
      ...item,
      alphaID: alphaID
    };
  });
};

export default AssignAlphaID;
